var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "account-preferences-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.handleInitialSubmit.apply(null, arguments)
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("settings.accountTab.accountLanguagePreference")
                  ) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c("div", { staticClass: "row moregage-form pretty-custom" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-sm-6 col-md-7 col-lg-8 col-xl-10 vertical-center",
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("settings.accountTab.preferredLanguage")
                            ) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-sm-6 col-md-5 col-lg-4 col-xl-2 my-auto text-right",
                  },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "form-group-material-no-label text-left",
                        model: {
                          value: _vm.localeLanguage,
                          callback: function ($$v) {
                            _vm.localeLanguage = $$v
                          },
                          expression: "localeLanguage",
                        },
                      },
                      [
                        _c("select2", {
                          ref: "select",
                          attrs: {
                            name: "localeLanguage",
                            value: _vm.localeLanguage,
                            data: _vm.localeLanguageOptions,
                            options: _vm.select2Options,
                          },
                          on: { change: _vm.handleLocaleChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }